import { bool, string } from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import Input from './input';
import 'react-datepicker/dist/react-datepicker.css';

function DatePicker({ placeholder, disabled, ...rest}) {
  return (
    <div className="se-datepicker">
      <ReactDatePicker
        placeholderText={placeholder}
        disabled={disabled}
        selected={rest.value}
        onChange={date => rest.onChange(date.toISOString)}
        customInput={
          <Input autocomplete="off"  />
        }
        {...rest} />
    </div>
  );
}

DatePicker.propTypes = {
  placeholder: string,
  disabled: bool,
}

DatePicker.defaultProps = {
  placeholder: 'Select date',
  disabled: false,
}

export default DatePicker;